import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { css, StyleSheet } from 'aphrodite';
import { Modal } from 'react-bootstrap';

import ProductsView from 'components/manage_manufacturers/shared/ProductsView';

function DuplicateBrandsProductsModal({ brand, onHide, globalVendorId }) {
  return (
    <Modal show={true} onHide={onHide} size="xl" className="lato" centered>
      <Modal.Header closeButton>
        <Modal.Title className={classNames(css(styles.heading))}>
          {brand.name} by {brand.global_manufacturer?.name}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ProductsView brandId={brand.id} globalVendorId={globalVendorId} />
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-start"></Modal.Footer>
    </Modal>
  );
}

const styles = StyleSheet.create({
  heading: {
    fontWeight: 'bold',
    fontFamily: 'Mont, sans-serif',
    fontSize: '1.5rem',
  },
});

DuplicateBrandsProductsModal.propTypes = {
  brand: PropTypes.object,
  onHide: PropTypes.func,
  globalVendorId: PropTypes.number,
};

export default DuplicateBrandsProductsModal;
